/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as OrgRouteRouteImport } from './routes/$org/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as OnboardRouteImport } from './routes/onboard'
import { Route as OrgActivityRouteImport } from './routes/$org/activity'
import { Route as OrgDashboardRouteImport } from './routes/$org/dashboard'
import { Route as OrgIntegrationsRouteRouteImport } from './routes/$org/integrations/route'
import { Route as OrgInventoryRouteImport } from './routes/$org/inventory'
import { Route as OrgSettingsRouteRouteImport } from './routes/$org/settings/route'
import { Route as OrgSuccessRouteImport } from './routes/$org/success'
import { Route as AuthLoginRouteImport } from './routes/auth/login'
import { Route as AuthSignupRouteImport } from './routes/auth/signup'
import { Route as AuthVerifyRouteImport } from './routes/auth/verify'
import { Route as OrgCollectionsIndexRouteImport } from './routes/$org/collections.index'
import { Route as OrgCollectionsIdRouteImport } from './routes/$org/collections.$id'
import { Route as OrgCollectionsNewRouteImport } from './routes/$org/collections.new'
import { Route as OrgProductsIdRouteImport } from './routes/$org/products.$id'
import { Route as OrgSettingsBillingRouteImport } from './routes/$org/settings/billing'
import { Route as OrgSettingsOrganizationRouteImport } from './routes/$org/settings/organization'
import { Route as OrgSettingsSkuGeneratorRouteImport } from './routes/$org/settings/sku-generator'
import { Route as OrgShopifySuccessRouteImport } from './routes/$org/shopify.success'
import { Route as AuthEbayCallbackRouteImport } from './routes/auth/ebay/callback'
import { Route as AuthShopifyIndexRouteImport } from './routes/auth/shopify/index'
import { Route as AuthShopifyCallbackRouteImport } from './routes/auth/shopify/callback'
import { Route as AuthShopifyConnectRouteImport } from './routes/auth/shopify/connect'
import { Route as AuthShopifyLoginRouteImport } from './routes/auth/shopify/login'
import { Route as AuthTiktokIndexRouteImport } from './routes/auth/tiktok/index'
import { Route as OrgIntegrationsEbayAliasAccountRouteImport } from './routes/$org/integrations/ebay.$alias.account'
import { Route as OrgIntegrationsEbayAliasImportRouteImport } from './routes/$org/integrations/ebay.$alias.import'
import { Route as OrgIntegrationsEbayAliasMessagingRouteImport } from './routes/$org/integrations/ebay.$alias.messaging'
import { Route as OrgIntegrationsEbayAliasReviewsRouteImport } from './routes/$org/integrations/ebay.$alias.reviews'
import { Route as OrgIntegrationsShopifyAliasAccountRouteImport } from './routes/$org/integrations/shopify.$alias.account'
import { Route as OrgIntegrationsShopifyAliasImportRouteImport } from './routes/$org/integrations/shopify.$alias.import'
import { Route as OrgIntegrationsTiktokAliasAccountRouteImport } from './routes/$org/integrations/tiktok.$alias.account'
import { Route as OrgIntegrationsTiktokAliasImportRouteImport } from './routes/$org/integrations/tiktok.$alias.import'

const OrgRouteRoute = OrgRouteRouteImport.update({
  id: '/$org',
  path: '/$org',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const OnboardRoute = OnboardRouteImport.update({
  id: '/onboard',
  path: '/onboard',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgActivityRoute = OrgActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgDashboardRoute = OrgDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgIntegrationsRouteRoute = OrgIntegrationsRouteRouteImport.update({
  id: '/integrations',
  path: '/integrations',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgInventoryRoute = OrgInventoryRouteImport.update({
  id: '/inventory',
  path: '/inventory',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgSettingsRouteRoute = OrgSettingsRouteRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgSuccessRoute = OrgSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => OrgRouteRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignupRoute = AuthSignupRouteImport.update({
  id: '/signup',
  path: '/signup',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthVerifyRoute = AuthVerifyRouteImport.update({
  id: '/verify',
  path: '/verify',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OrgCollectionsIndexRoute = OrgCollectionsIndexRouteImport.update({
  id: '/collections/',
  path: '/collections/',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgCollectionsIdRoute = OrgCollectionsIdRouteImport.update({
  id: '/collections/$id',
  path: '/collections/$id',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgCollectionsNewRoute = OrgCollectionsNewRouteImport.update({
  id: '/collections/new',
  path: '/collections/new',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgProductsIdRoute = OrgProductsIdRouteImport.update({
  id: '/products/$id',
  path: '/products/$id',
  getParentRoute: () => OrgRouteRoute,
} as any)
const OrgSettingsBillingRoute = OrgSettingsBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => OrgSettingsRouteRoute,
} as any)
const OrgSettingsOrganizationRoute = OrgSettingsOrganizationRouteImport.update({
  id: '/organization',
  path: '/organization',
  getParentRoute: () => OrgSettingsRouteRoute,
} as any)
const OrgSettingsSkuGeneratorRoute = OrgSettingsSkuGeneratorRouteImport.update({
  id: '/sku-generator',
  path: '/sku-generator',
  getParentRoute: () => OrgSettingsRouteRoute,
} as any)
const OrgShopifySuccessRoute = OrgShopifySuccessRouteImport.update({
  id: '/shopify/success',
  path: '/shopify/success',
  getParentRoute: () => OrgRouteRoute,
} as any)
const AuthEbayCallbackRoute = AuthEbayCallbackRouteImport.update({
  id: '/ebay/callback',
  path: '/ebay/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthShopifyIndexRoute = AuthShopifyIndexRouteImport.update({
  id: '/shopify/',
  path: '/shopify/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthShopifyCallbackRoute = AuthShopifyCallbackRouteImport.update({
  id: '/shopify/callback',
  path: '/shopify/callback',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthShopifyConnectRoute = AuthShopifyConnectRouteImport.update({
  id: '/shopify/connect',
  path: '/shopify/connect',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthShopifyLoginRoute = AuthShopifyLoginRouteImport.update({
  id: '/shopify/login',
  path: '/shopify/login',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthTiktokIndexRoute = AuthTiktokIndexRouteImport.update({
  id: '/tiktok/',
  path: '/tiktok/',
  getParentRoute: () => AuthRouteRoute,
} as any)
const OrgIntegrationsEbayAliasAccountRoute =
  OrgIntegrationsEbayAliasAccountRouteImport.update({
    id: '/ebay/$alias/account',
    path: '/ebay/$alias/account',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsEbayAliasImportRoute =
  OrgIntegrationsEbayAliasImportRouteImport.update({
    id: '/ebay/$alias/import',
    path: '/ebay/$alias/import',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsEbayAliasMessagingRoute =
  OrgIntegrationsEbayAliasMessagingRouteImport.update({
    id: '/ebay/$alias/messaging',
    path: '/ebay/$alias/messaging',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsEbayAliasReviewsRoute =
  OrgIntegrationsEbayAliasReviewsRouteImport.update({
    id: '/ebay/$alias/reviews',
    path: '/ebay/$alias/reviews',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsShopifyAliasAccountRoute =
  OrgIntegrationsShopifyAliasAccountRouteImport.update({
    id: '/shopify/$alias/account',
    path: '/shopify/$alias/account',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsShopifyAliasImportRoute =
  OrgIntegrationsShopifyAliasImportRouteImport.update({
    id: '/shopify/$alias/import',
    path: '/shopify/$alias/import',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsTiktokAliasAccountRoute =
  OrgIntegrationsTiktokAliasAccountRouteImport.update({
    id: '/tiktok/$alias/account',
    path: '/tiktok/$alias/account',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)
const OrgIntegrationsTiktokAliasImportRoute =
  OrgIntegrationsTiktokAliasImportRouteImport.update({
    id: '/tiktok/$alias/import',
    path: '/tiktok/$alias/import',
    getParentRoute: () => OrgIntegrationsRouteRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/$org': typeof OrgRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/$org/integrations': typeof OrgIntegrationsRouteRouteWithChildren
  '/$org/settings': typeof OrgSettingsRouteRouteWithChildren
  '/$org/activity': typeof OrgActivityRoute
  '/$org/dashboard': typeof OrgDashboardRoute
  '/$org/inventory': typeof OrgInventoryRoute
  '/$org/success': typeof OrgSuccessRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/$org/collections/$id': typeof OrgCollectionsIdRoute
  '/$org/collections/new': typeof OrgCollectionsNewRoute
  '/$org/products/$id': typeof OrgProductsIdRoute
  '/$org/settings/billing': typeof OrgSettingsBillingRoute
  '/$org/settings/organization': typeof OrgSettingsOrganizationRoute
  '/$org/settings/sku-generator': typeof OrgSettingsSkuGeneratorRoute
  '/$org/shopify/success': typeof OrgShopifySuccessRoute
  '/auth/ebay/callback': typeof AuthEbayCallbackRoute
  '/auth/shopify/callback': typeof AuthShopifyCallbackRoute
  '/auth/shopify/connect': typeof AuthShopifyConnectRoute
  '/auth/shopify/login': typeof AuthShopifyLoginRoute
  '/$org/collections/': typeof OrgCollectionsIndexRoute
  '/auth/shopify/': typeof AuthShopifyIndexRoute
  '/auth/tiktok/': typeof AuthTiktokIndexRoute
  '/$org/integrations/ebay/$alias/account': typeof OrgIntegrationsEbayAliasAccountRoute
  '/$org/integrations/ebay/$alias/import': typeof OrgIntegrationsEbayAliasImportRoute
  '/$org/integrations/ebay/$alias/messaging': typeof OrgIntegrationsEbayAliasMessagingRoute
  '/$org/integrations/ebay/$alias/reviews': typeof OrgIntegrationsEbayAliasReviewsRoute
  '/$org/integrations/shopify/$alias/account': typeof OrgIntegrationsShopifyAliasAccountRoute
  '/$org/integrations/shopify/$alias/import': typeof OrgIntegrationsShopifyAliasImportRoute
  '/$org/integrations/tiktok/$alias/account': typeof OrgIntegrationsTiktokAliasAccountRoute
  '/$org/integrations/tiktok/$alias/import': typeof OrgIntegrationsTiktokAliasImportRoute
}
export interface FileRoutesByTo {
  '/$org': typeof OrgRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/$org/integrations': typeof OrgIntegrationsRouteRouteWithChildren
  '/$org/settings': typeof OrgSettingsRouteRouteWithChildren
  '/$org/activity': typeof OrgActivityRoute
  '/$org/dashboard': typeof OrgDashboardRoute
  '/$org/inventory': typeof OrgInventoryRoute
  '/$org/success': typeof OrgSuccessRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/$org/collections/$id': typeof OrgCollectionsIdRoute
  '/$org/collections/new': typeof OrgCollectionsNewRoute
  '/$org/products/$id': typeof OrgProductsIdRoute
  '/$org/settings/billing': typeof OrgSettingsBillingRoute
  '/$org/settings/organization': typeof OrgSettingsOrganizationRoute
  '/$org/settings/sku-generator': typeof OrgSettingsSkuGeneratorRoute
  '/$org/shopify/success': typeof OrgShopifySuccessRoute
  '/auth/ebay/callback': typeof AuthEbayCallbackRoute
  '/auth/shopify/callback': typeof AuthShopifyCallbackRoute
  '/auth/shopify/connect': typeof AuthShopifyConnectRoute
  '/auth/shopify/login': typeof AuthShopifyLoginRoute
  '/$org/collections': typeof OrgCollectionsIndexRoute
  '/auth/shopify': typeof AuthShopifyIndexRoute
  '/auth/tiktok': typeof AuthTiktokIndexRoute
  '/$org/integrations/ebay/$alias/account': typeof OrgIntegrationsEbayAliasAccountRoute
  '/$org/integrations/ebay/$alias/import': typeof OrgIntegrationsEbayAliasImportRoute
  '/$org/integrations/ebay/$alias/messaging': typeof OrgIntegrationsEbayAliasMessagingRoute
  '/$org/integrations/ebay/$alias/reviews': typeof OrgIntegrationsEbayAliasReviewsRoute
  '/$org/integrations/shopify/$alias/account': typeof OrgIntegrationsShopifyAliasAccountRoute
  '/$org/integrations/shopify/$alias/import': typeof OrgIntegrationsShopifyAliasImportRoute
  '/$org/integrations/tiktok/$alias/account': typeof OrgIntegrationsTiktokAliasAccountRoute
  '/$org/integrations/tiktok/$alias/import': typeof OrgIntegrationsTiktokAliasImportRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/$org': typeof OrgRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/onboard': typeof OnboardRoute
  '/$org/integrations': typeof OrgIntegrationsRouteRouteWithChildren
  '/$org/settings': typeof OrgSettingsRouteRouteWithChildren
  '/$org/activity': typeof OrgActivityRoute
  '/$org/dashboard': typeof OrgDashboardRoute
  '/$org/inventory': typeof OrgInventoryRoute
  '/$org/success': typeof OrgSuccessRoute
  '/auth/login': typeof AuthLoginRoute
  '/auth/signup': typeof AuthSignupRoute
  '/auth/verify': typeof AuthVerifyRoute
  '/$org/collections/$id': typeof OrgCollectionsIdRoute
  '/$org/collections/new': typeof OrgCollectionsNewRoute
  '/$org/products/$id': typeof OrgProductsIdRoute
  '/$org/settings/billing': typeof OrgSettingsBillingRoute
  '/$org/settings/organization': typeof OrgSettingsOrganizationRoute
  '/$org/settings/sku-generator': typeof OrgSettingsSkuGeneratorRoute
  '/$org/shopify/success': typeof OrgShopifySuccessRoute
  '/auth/ebay/callback': typeof AuthEbayCallbackRoute
  '/auth/shopify/callback': typeof AuthShopifyCallbackRoute
  '/auth/shopify/connect': typeof AuthShopifyConnectRoute
  '/auth/shopify/login': typeof AuthShopifyLoginRoute
  '/$org/collections/': typeof OrgCollectionsIndexRoute
  '/auth/shopify/': typeof AuthShopifyIndexRoute
  '/auth/tiktok/': typeof AuthTiktokIndexRoute
  '/$org/integrations/ebay/$alias/account': typeof OrgIntegrationsEbayAliasAccountRoute
  '/$org/integrations/ebay/$alias/import': typeof OrgIntegrationsEbayAliasImportRoute
  '/$org/integrations/ebay/$alias/messaging': typeof OrgIntegrationsEbayAliasMessagingRoute
  '/$org/integrations/ebay/$alias/reviews': typeof OrgIntegrationsEbayAliasReviewsRoute
  '/$org/integrations/shopify/$alias/account': typeof OrgIntegrationsShopifyAliasAccountRoute
  '/$org/integrations/shopify/$alias/import': typeof OrgIntegrationsShopifyAliasImportRoute
  '/$org/integrations/tiktok/$alias/account': typeof OrgIntegrationsTiktokAliasAccountRoute
  '/$org/integrations/tiktok/$alias/import': typeof OrgIntegrationsTiktokAliasImportRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/$org'
    | '/auth'
    | '/onboard'
    | '/$org/integrations'
    | '/$org/settings'
    | '/$org/activity'
    | '/$org/dashboard'
    | '/$org/inventory'
    | '/$org/success'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/verify'
    | '/$org/collections/$id'
    | '/$org/collections/new'
    | '/$org/products/$id'
    | '/$org/settings/billing'
    | '/$org/settings/organization'
    | '/$org/settings/sku-generator'
    | '/$org/shopify/success'
    | '/auth/ebay/callback'
    | '/auth/shopify/callback'
    | '/auth/shopify/connect'
    | '/auth/shopify/login'
    | '/$org/collections/'
    | '/auth/shopify/'
    | '/auth/tiktok/'
    | '/$org/integrations/ebay/$alias/account'
    | '/$org/integrations/ebay/$alias/import'
    | '/$org/integrations/ebay/$alias/messaging'
    | '/$org/integrations/ebay/$alias/reviews'
    | '/$org/integrations/shopify/$alias/account'
    | '/$org/integrations/shopify/$alias/import'
    | '/$org/integrations/tiktok/$alias/account'
    | '/$org/integrations/tiktok/$alias/import'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/$org'
    | '/auth'
    | '/onboard'
    | '/$org/integrations'
    | '/$org/settings'
    | '/$org/activity'
    | '/$org/dashboard'
    | '/$org/inventory'
    | '/$org/success'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/verify'
    | '/$org/collections/$id'
    | '/$org/collections/new'
    | '/$org/products/$id'
    | '/$org/settings/billing'
    | '/$org/settings/organization'
    | '/$org/settings/sku-generator'
    | '/$org/shopify/success'
    | '/auth/ebay/callback'
    | '/auth/shopify/callback'
    | '/auth/shopify/connect'
    | '/auth/shopify/login'
    | '/$org/collections'
    | '/auth/shopify'
    | '/auth/tiktok'
    | '/$org/integrations/ebay/$alias/account'
    | '/$org/integrations/ebay/$alias/import'
    | '/$org/integrations/ebay/$alias/messaging'
    | '/$org/integrations/ebay/$alias/reviews'
    | '/$org/integrations/shopify/$alias/account'
    | '/$org/integrations/shopify/$alias/import'
    | '/$org/integrations/tiktok/$alias/account'
    | '/$org/integrations/tiktok/$alias/import'
  id:
    | '__root__'
    | '/$org'
    | '/auth'
    | '/onboard'
    | '/$org/integrations'
    | '/$org/settings'
    | '/$org/activity'
    | '/$org/dashboard'
    | '/$org/inventory'
    | '/$org/success'
    | '/auth/login'
    | '/auth/signup'
    | '/auth/verify'
    | '/$org/collections/$id'
    | '/$org/collections/new'
    | '/$org/products/$id'
    | '/$org/settings/billing'
    | '/$org/settings/organization'
    | '/$org/settings/sku-generator'
    | '/$org/shopify/success'
    | '/auth/ebay/callback'
    | '/auth/shopify/callback'
    | '/auth/shopify/connect'
    | '/auth/shopify/login'
    | '/$org/collections/'
    | '/auth/shopify/'
    | '/auth/tiktok/'
    | '/$org/integrations/ebay/$alias/account'
    | '/$org/integrations/ebay/$alias/import'
    | '/$org/integrations/ebay/$alias/messaging'
    | '/$org/integrations/ebay/$alias/reviews'
    | '/$org/integrations/shopify/$alias/account'
    | '/$org/integrations/shopify/$alias/import'
    | '/$org/integrations/tiktok/$alias/account'
    | '/$org/integrations/tiktok/$alias/import'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  OrgRouteRoute: typeof OrgRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  OnboardRoute: typeof OnboardRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/$org': {
      id: '/$org'
      path: '/$org'
      fullPath: '/$org'
      preLoaderRoute: typeof OrgRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/onboard': {
      id: '/onboard'
      path: '/onboard'
      fullPath: '/onboard'
      preLoaderRoute: typeof OnboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/activity': {
      id: '/$org/activity'
      path: '/activity'
      fullPath: '/$org/activity'
      preLoaderRoute: typeof OrgActivityRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/dashboard': {
      id: '/$org/dashboard'
      path: '/dashboard'
      fullPath: '/$org/dashboard'
      preLoaderRoute: typeof OrgDashboardRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/integrations': {
      id: '/$org/integrations'
      path: '/integrations'
      fullPath: '/$org/integrations'
      preLoaderRoute: typeof OrgIntegrationsRouteRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/inventory': {
      id: '/$org/inventory'
      path: '/inventory'
      fullPath: '/$org/inventory'
      preLoaderRoute: typeof OrgInventoryRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/settings': {
      id: '/$org/settings'
      path: '/settings'
      fullPath: '/$org/settings'
      preLoaderRoute: typeof OrgSettingsRouteRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/success': {
      id: '/$org/success'
      path: '/success'
      fullPath: '/$org/success'
      preLoaderRoute: typeof OrgSuccessRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/auth/login': {
      id: '/auth/login'
      path: '/login'
      fullPath: '/auth/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/signup': {
      id: '/auth/signup'
      path: '/signup'
      fullPath: '/auth/signup'
      preLoaderRoute: typeof AuthSignupRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/verify': {
      id: '/auth/verify'
      path: '/verify'
      fullPath: '/auth/verify'
      preLoaderRoute: typeof AuthVerifyRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/$org/collections/': {
      id: '/$org/collections/'
      path: '/collections'
      fullPath: '/$org/collections/'
      preLoaderRoute: typeof OrgCollectionsIndexRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/collections/$id': {
      id: '/$org/collections/$id'
      path: '/collections/$id'
      fullPath: '/$org/collections/$id'
      preLoaderRoute: typeof OrgCollectionsIdRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/collections/new': {
      id: '/$org/collections/new'
      path: '/collections/new'
      fullPath: '/$org/collections/new'
      preLoaderRoute: typeof OrgCollectionsNewRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/products/$id': {
      id: '/$org/products/$id'
      path: '/products/$id'
      fullPath: '/$org/products/$id'
      preLoaderRoute: typeof OrgProductsIdRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/$org/settings/billing': {
      id: '/$org/settings/billing'
      path: '/billing'
      fullPath: '/$org/settings/billing'
      preLoaderRoute: typeof OrgSettingsBillingRouteImport
      parentRoute: typeof OrgSettingsRouteRoute
    }
    '/$org/settings/organization': {
      id: '/$org/settings/organization'
      path: '/organization'
      fullPath: '/$org/settings/organization'
      preLoaderRoute: typeof OrgSettingsOrganizationRouteImport
      parentRoute: typeof OrgSettingsRouteRoute
    }
    '/$org/settings/sku-generator': {
      id: '/$org/settings/sku-generator'
      path: '/sku-generator'
      fullPath: '/$org/settings/sku-generator'
      preLoaderRoute: typeof OrgSettingsSkuGeneratorRouteImport
      parentRoute: typeof OrgSettingsRouteRoute
    }
    '/$org/shopify/success': {
      id: '/$org/shopify/success'
      path: '/shopify/success'
      fullPath: '/$org/shopify/success'
      preLoaderRoute: typeof OrgShopifySuccessRouteImport
      parentRoute: typeof OrgRouteRoute
    }
    '/auth/ebay/callback': {
      id: '/auth/ebay/callback'
      path: '/ebay/callback'
      fullPath: '/auth/ebay/callback'
      preLoaderRoute: typeof AuthEbayCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/shopify/': {
      id: '/auth/shopify/'
      path: '/shopify'
      fullPath: '/auth/shopify/'
      preLoaderRoute: typeof AuthShopifyIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/shopify/callback': {
      id: '/auth/shopify/callback'
      path: '/shopify/callback'
      fullPath: '/auth/shopify/callback'
      preLoaderRoute: typeof AuthShopifyCallbackRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/shopify/connect': {
      id: '/auth/shopify/connect'
      path: '/shopify/connect'
      fullPath: '/auth/shopify/connect'
      preLoaderRoute: typeof AuthShopifyConnectRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/shopify/login': {
      id: '/auth/shopify/login'
      path: '/shopify/login'
      fullPath: '/auth/shopify/login'
      preLoaderRoute: typeof AuthShopifyLoginRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/tiktok/': {
      id: '/auth/tiktok/'
      path: '/tiktok'
      fullPath: '/auth/tiktok/'
      preLoaderRoute: typeof AuthTiktokIndexRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/$org/integrations/ebay/$alias/account': {
      id: '/$org/integrations/ebay/$alias/account'
      path: '/ebay/$alias/account'
      fullPath: '/$org/integrations/ebay/$alias/account'
      preLoaderRoute: typeof OrgIntegrationsEbayAliasAccountRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/ebay/$alias/import': {
      id: '/$org/integrations/ebay/$alias/import'
      path: '/ebay/$alias/import'
      fullPath: '/$org/integrations/ebay/$alias/import'
      preLoaderRoute: typeof OrgIntegrationsEbayAliasImportRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/ebay/$alias/messaging': {
      id: '/$org/integrations/ebay/$alias/messaging'
      path: '/ebay/$alias/messaging'
      fullPath: '/$org/integrations/ebay/$alias/messaging'
      preLoaderRoute: typeof OrgIntegrationsEbayAliasMessagingRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/ebay/$alias/reviews': {
      id: '/$org/integrations/ebay/$alias/reviews'
      path: '/ebay/$alias/reviews'
      fullPath: '/$org/integrations/ebay/$alias/reviews'
      preLoaderRoute: typeof OrgIntegrationsEbayAliasReviewsRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/shopify/$alias/account': {
      id: '/$org/integrations/shopify/$alias/account'
      path: '/shopify/$alias/account'
      fullPath: '/$org/integrations/shopify/$alias/account'
      preLoaderRoute: typeof OrgIntegrationsShopifyAliasAccountRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/shopify/$alias/import': {
      id: '/$org/integrations/shopify/$alias/import'
      path: '/shopify/$alias/import'
      fullPath: '/$org/integrations/shopify/$alias/import'
      preLoaderRoute: typeof OrgIntegrationsShopifyAliasImportRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/tiktok/$alias/account': {
      id: '/$org/integrations/tiktok/$alias/account'
      path: '/tiktok/$alias/account'
      fullPath: '/$org/integrations/tiktok/$alias/account'
      preLoaderRoute: typeof OrgIntegrationsTiktokAliasAccountRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
    '/$org/integrations/tiktok/$alias/import': {
      id: '/$org/integrations/tiktok/$alias/import'
      path: '/tiktok/$alias/import'
      fullPath: '/$org/integrations/tiktok/$alias/import'
      preLoaderRoute: typeof OrgIntegrationsTiktokAliasImportRouteImport
      parentRoute: typeof OrgIntegrationsRouteRoute
    }
  }
}

interface OrgIntegrationsRouteRouteChildren {
  OrgIntegrationsEbayAliasAccountRoute: typeof OrgIntegrationsEbayAliasAccountRoute
  OrgIntegrationsEbayAliasImportRoute: typeof OrgIntegrationsEbayAliasImportRoute
  OrgIntegrationsEbayAliasMessagingRoute: typeof OrgIntegrationsEbayAliasMessagingRoute
  OrgIntegrationsEbayAliasReviewsRoute: typeof OrgIntegrationsEbayAliasReviewsRoute
  OrgIntegrationsShopifyAliasAccountRoute: typeof OrgIntegrationsShopifyAliasAccountRoute
  OrgIntegrationsShopifyAliasImportRoute: typeof OrgIntegrationsShopifyAliasImportRoute
  OrgIntegrationsTiktokAliasAccountRoute: typeof OrgIntegrationsTiktokAliasAccountRoute
  OrgIntegrationsTiktokAliasImportRoute: typeof OrgIntegrationsTiktokAliasImportRoute
}

const OrgIntegrationsRouteRouteChildren: OrgIntegrationsRouteRouteChildren = {
  OrgIntegrationsEbayAliasAccountRoute: OrgIntegrationsEbayAliasAccountRoute,
  OrgIntegrationsEbayAliasImportRoute: OrgIntegrationsEbayAliasImportRoute,
  OrgIntegrationsEbayAliasMessagingRoute:
    OrgIntegrationsEbayAliasMessagingRoute,
  OrgIntegrationsEbayAliasReviewsRoute: OrgIntegrationsEbayAliasReviewsRoute,
  OrgIntegrationsShopifyAliasAccountRoute:
    OrgIntegrationsShopifyAliasAccountRoute,
  OrgIntegrationsShopifyAliasImportRoute:
    OrgIntegrationsShopifyAliasImportRoute,
  OrgIntegrationsTiktokAliasAccountRoute:
    OrgIntegrationsTiktokAliasAccountRoute,
  OrgIntegrationsTiktokAliasImportRoute: OrgIntegrationsTiktokAliasImportRoute,
}

const OrgIntegrationsRouteRouteWithChildren =
  OrgIntegrationsRouteRoute._addFileChildren(OrgIntegrationsRouteRouteChildren)

interface OrgSettingsRouteRouteChildren {
  OrgSettingsBillingRoute: typeof OrgSettingsBillingRoute
  OrgSettingsOrganizationRoute: typeof OrgSettingsOrganizationRoute
  OrgSettingsSkuGeneratorRoute: typeof OrgSettingsSkuGeneratorRoute
}

const OrgSettingsRouteRouteChildren: OrgSettingsRouteRouteChildren = {
  OrgSettingsBillingRoute: OrgSettingsBillingRoute,
  OrgSettingsOrganizationRoute: OrgSettingsOrganizationRoute,
  OrgSettingsSkuGeneratorRoute: OrgSettingsSkuGeneratorRoute,
}

const OrgSettingsRouteRouteWithChildren =
  OrgSettingsRouteRoute._addFileChildren(OrgSettingsRouteRouteChildren)

interface OrgRouteRouteChildren {
  OrgIntegrationsRouteRoute: typeof OrgIntegrationsRouteRouteWithChildren
  OrgSettingsRouteRoute: typeof OrgSettingsRouteRouteWithChildren
  OrgActivityRoute: typeof OrgActivityRoute
  OrgDashboardRoute: typeof OrgDashboardRoute
  OrgInventoryRoute: typeof OrgInventoryRoute
  OrgSuccessRoute: typeof OrgSuccessRoute
  OrgCollectionsIdRoute: typeof OrgCollectionsIdRoute
  OrgCollectionsNewRoute: typeof OrgCollectionsNewRoute
  OrgProductsIdRoute: typeof OrgProductsIdRoute
  OrgShopifySuccessRoute: typeof OrgShopifySuccessRoute
  OrgCollectionsIndexRoute: typeof OrgCollectionsIndexRoute
}

const OrgRouteRouteChildren: OrgRouteRouteChildren = {
  OrgIntegrationsRouteRoute: OrgIntegrationsRouteRouteWithChildren,
  OrgSettingsRouteRoute: OrgSettingsRouteRouteWithChildren,
  OrgActivityRoute: OrgActivityRoute,
  OrgDashboardRoute: OrgDashboardRoute,
  OrgInventoryRoute: OrgInventoryRoute,
  OrgSuccessRoute: OrgSuccessRoute,
  OrgCollectionsIdRoute: OrgCollectionsIdRoute,
  OrgCollectionsNewRoute: OrgCollectionsNewRoute,
  OrgProductsIdRoute: OrgProductsIdRoute,
  OrgShopifySuccessRoute: OrgShopifySuccessRoute,
  OrgCollectionsIndexRoute: OrgCollectionsIndexRoute,
}

const OrgRouteRouteWithChildren = OrgRouteRoute._addFileChildren(
  OrgRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthLoginRoute: typeof AuthLoginRoute
  AuthSignupRoute: typeof AuthSignupRoute
  AuthVerifyRoute: typeof AuthVerifyRoute
  AuthEbayCallbackRoute: typeof AuthEbayCallbackRoute
  AuthShopifyCallbackRoute: typeof AuthShopifyCallbackRoute
  AuthShopifyConnectRoute: typeof AuthShopifyConnectRoute
  AuthShopifyLoginRoute: typeof AuthShopifyLoginRoute
  AuthShopifyIndexRoute: typeof AuthShopifyIndexRoute
  AuthTiktokIndexRoute: typeof AuthTiktokIndexRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthLoginRoute: AuthLoginRoute,
  AuthSignupRoute: AuthSignupRoute,
  AuthVerifyRoute: AuthVerifyRoute,
  AuthEbayCallbackRoute: AuthEbayCallbackRoute,
  AuthShopifyCallbackRoute: AuthShopifyCallbackRoute,
  AuthShopifyConnectRoute: AuthShopifyConnectRoute,
  AuthShopifyLoginRoute: AuthShopifyLoginRoute,
  AuthShopifyIndexRoute: AuthShopifyIndexRoute,
  AuthTiktokIndexRoute: AuthTiktokIndexRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  OrgRouteRoute: OrgRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  OnboardRoute: OnboardRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
